import React from "react";

/**
 * Wordmark logo with the "energy ring" mark (breathing / undulating).
 * The mark PNG has a black background, blended via mix-blend: screen
 * so only the glowing ring shows.
 */
export const Logo = ({ size = "md", showSubtitle = false, className = "" }) => {
  const titleSize =
    size === "xl"
      ? "text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
      : size === "lg"
        ? "text-3xl sm:text-4xl"
        : "text-xl sm:text-2xl";

  const markSize =
    size === "xl"
      ? "w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28"
      : size === "lg"
        ? "w-14 h-14 sm:w-16 sm:h-16"
        : "w-9 h-9 sm:w-10 sm:h-10";

  return (
    <div
      className={`inline-flex items-center gap-1 sm:gap-1.5 ${className}`}
      data-testid="mmg-logo"
    >
      <span
        className={`relative inline-block shrink-0 ${markSize}`}
        aria-hidden="true"
      >
        {/* Inner phosphorescent core */}
        <span className="logo-mark-inner-glow" />
        {/* Outer phosphorescent aura */}
        <span className="logo-mark-outer-glow" />
        <img
          src="/mmg-logo.png"
          alt=""
          className="relative w-full h-full object-contain logo-mark-breathe"
          style={{ mixBlendMode: "screen" }}
          draggable={false}
        />
      </span>
      <div className="flex flex-col leading-none">
        <span
          className={`font-heading font-medium tracking-tight whitespace-nowrap ${titleSize} text-white`}
        >
          My Mood <span className="font-medium">Groove</span>
        </span>
        {showSubtitle ? (
          <span className="font-body text-xs sm:text-sm text-zinc-400 mt-1 tracking-wide">
            A personal awareness and soundscape experience
          </span>
        ) : null}
      </div>
    </div>
  );
};

/**
 * Standalone breathing ring mark — reusable anywhere the wave-bars icon was used.
 * Accepts a size class ("sm" | "md" | "lg" | "xl").
 */
export const LogoMark = ({ size = "md", className = "" }) => {
  const markSize =
    size === "xl"
      ? "w-20 h-20 sm:w-24 sm:h-24"
      : size === "lg"
        ? "w-14 h-14 sm:w-16 sm:h-16"
        : size === "md"
          ? "w-10 h-10"
          : "w-6 h-6";
  return (
    <span
      className={`relative inline-block shrink-0 ${markSize} ${className}`}
      aria-hidden="true"
      data-testid="mmg-logo-mark"
    >
      <span className="logo-mark-inner-glow" />
      <span className="logo-mark-outer-glow" />
      <img
        src="/mmg-logo.png"
        alt=""
        className="relative w-full h-full object-contain logo-mark-breathe"
        style={{ mixBlendMode: "screen" }}
        draggable={false}
      />
    </span>
  );
};

export default Logo;
